import { render, staticRenderFns } from "./CajaTotales.vue?vue&type=template&id=ee3c6db0"
import script from "./CajaTotales.vue?vue&type=script&lang=js"
export * from "./CajaTotales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports